import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";
import {athubAxios} from "../../util";

const point = new AthubRestResource({server: DCIM_SERVER, resource: 'point'});

point.findByGuid = (guid) => {
    let url = `${DCIM_SERVER}/point/guid/${guid}`;
    let promise = new Promise((resolve, reject) => {
        athubAxios.get(url).then(responseBody => {
            if (responseBody.status == 200 && responseBody.data.code == '200') {
                resolve(responseBody.data.data);
            } else {
                reject(responseBody.data.msg);
            }
        })
    });
    return promise;
};

export default point;
